import styled from 'styled-components';
import { AceEditorTheme } from 'modules/aceEditor/types';
import { InfoBanner } from 'ui/banner';
import { PageHeader } from 'ui/pageHeader';
import { spacing } from 'ui/theme';
import { JsonEditorContextProvider } from '../context/JsonEditorProvider';
import { DbConfigContextProvider } from '../context/DbConfigProvider';
import { ActionButtons } from './ActionButtons';
import { ConfigSelector } from './ConfigSelector';
import { JsonEditor } from './JsonEditor';

const InfoBannerWrapper = styled.div`
  margin: ${spacing.double} 0;
  width: fit-content;
`;

const ConfigForm = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: ${spacing.double};
  row-gap: ${spacing.base};
`;

export const testIds = {
  header: 'admin-db-configs-header',
};

export const DatabaseConfigs = () => {
  return (
    <JsonEditorContextProvider aceEditorTheme={AceEditorTheme.Monokai}>
      <DbConfigContextProvider>
        <PageHeader data-test={testIds.header}>Database configs</PageHeader>
        <InfoBannerWrapper>
          <InfoBanner>Select a database config to start</InfoBanner>
        </InfoBannerWrapper>
        <ConfigForm>
          <section>
            <ConfigSelector />
          </section>
          <section>
            <JsonEditor />
          </section>
          <section>
            <ActionButtons />
          </section>
        </ConfigForm>
      </DbConfigContextProvider>
    </JsonEditorContextProvider>
  );
};

export default DatabaseConfigs;
